export const DASH_MEDIDAS_SECTION_IDS = [
  "dash-filtros",
  "dash-medias-curvas",
  "dash-analise-inteligente",
  "dash-graficos",
  "dash-editar-equipamento",
];

export const DASH_MEDIDAS_SECTION_ORDER_KEY = "dashMedidasSectionOrder";

export const getDefaultSectionOrder = () => [...DASH_MEDIDAS_SECTION_IDS];

export const readSectionOrder = () => {
  try {
    let stored = localStorage.getItem(DASH_MEDIDAS_SECTION_ORDER_KEY);

    if (!stored) {
      const sessionStored = sessionStorage.getItem(DASH_MEDIDAS_SECTION_ORDER_KEY);
      if (sessionStored) {
        localStorage.setItem(DASH_MEDIDAS_SECTION_ORDER_KEY, sessionStored);
        sessionStorage.removeItem(DASH_MEDIDAS_SECTION_ORDER_KEY);
        stored = sessionStored;
      }
    }

    if (!stored) return getDefaultSectionOrder();

    const parsed = JSON.parse(stored);
    if (!Array.isArray(parsed)) return getDefaultSectionOrder();

    const valid = parsed.filter((id) => DASH_MEDIDAS_SECTION_IDS.includes(id));
    const unique = [...new Set(valid)];
    const missing = DASH_MEDIDAS_SECTION_IDS.filter((id) => !unique.includes(id));
    return [...unique, ...missing];
  } catch {
    return getDefaultSectionOrder();
  }
};

/** Garante que nenhuma seção visível se perca durante o drag-and-drop. */
export const sanitizeVisibleOrder = (candidate, baseline) => {
  if (!Array.isArray(baseline) || baseline.length === 0) {
    return getDefaultSectionOrder();
  }

  const baselineSet = new Set(baseline);
  const seen = new Set();
  const result = [];

  (Array.isArray(candidate) ? candidate : []).forEach((id) => {
    if (baselineSet.has(id) && !seen.has(id)) {
      seen.add(id);
      result.push(id);
    }
  });

  baseline.forEach((id) => {
    if (!seen.has(id)) {
      result.push(id);
    }
  });

  return result;
};

export const persistSectionOrder = (order) => {
  try {
    localStorage.setItem(DASH_MEDIDAS_SECTION_ORDER_KEY, JSON.stringify(order));
  } catch {
    /* ignore */
  }
};

export const getVisibleSectionOrder = (order, { showEditarEquipamento }) =>
  order.filter(
    (id) => id !== "dash-editar-equipamento" || showEditarEquipamento
  );

export const mergeVisibleSectionReorder = (fullOrder, visibleOrder, newVisibleOrder) => {
  const next = [...fullOrder];
  const visibleIndices = fullOrder
    .map((id, index) => (visibleOrder.includes(id) ? index : -1))
    .filter((index) => index >= 0);

  newVisibleOrder.forEach((id, index) => {
    next[visibleIndices[index]] = id;
  });

  return next;
};
